import { Component } from "@angular/core";
import { ActivityService } from "../service/activity.service";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons/faExclamationCircle";
import { faFile } from "@fortawesome/free-solid-svg-icons/faFile";
import { Strings } from "../../shared/tools/Strings";
import { TaskState, TaskType } from "cilor-db-api-shared";

@Component({
  selector: "app-activity-page",
  templateUrl: "./activity-page.component.html",
  styleUrls: ["./activity-page.component.scss"]
})
export class ActivityPageComponent {
  public faCheck = faCheck;
  public faExclamationCircle = faExclamationCircle;
  public faFile = faFile;
  public TaskState = TaskState;

  constructor(
    public readonly activityService: ActivityService,
  ) {
  }

  public getProgressDisplay(progress: number): string {
    return Math.round(progress * 100).toFixed(0) + " %";
  }

  public getDate(s: string | null): string {
    if (s == null) {
      return "";
    }
    const date = new Date(s);
    return date.toLocaleString();
  }

  public getDurationSeconds(start: string, end: string): string {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const seconds = ((endDate.getTime() - startDate.getTime()) / 1000).toFixed(0);
    return seconds;
  }

  public getTypeDisplay(type: TaskType): string {
    switch (type) {
      case TaskType.calculations: return Strings.calculations;
      case TaskType.productsImport: return Strings.productsImport;
      case TaskType.valuesImport: return Strings.valuesImport;
      case TaskType.brillantsImport: return Strings.brillantsImport;
      case TaskType.artifactsGeneration: return Strings.artifactsGeneration;
      default: return type;
    }
  }
}
